<template>
  <div id="header" 
  @mouseleave="service=false; models=false"
  :class="{active: (service || models) || smallScreen}">

    <!-- main header - display in the desktop screens -->
    <header v-if="bigScreen" ref="desktopHeader">
      
      <!-- menu -->
      <div>
          <router-link to="/" tag="a" name="chery logo, go to home page">
            <img loading="lazy" src="../assets/chery_black.webp" alt="">
          </router-link>
          <nav>
            <a @mouseenter="service=false; models=true; bindCurrentModel('Tiggo');">models</a>
            <a @mouseenter="models=false; service=true;">service</a>
            <router-link to="/showroom" tag="a"  @mouseenter="service=false; models=false;">showroom</router-link>
            <router-link to="/about" tag="a" @mouseenter="service=false; models=false;">about chery</router-link>
            <router-link to="/contact" tag="a" @mouseenter="service=false; models=false;">contact us</router-link>
            <router-link to="/news" tag="a" @mouseenter="service=false; models=false;">news</router-link>
          </nav>
      </div>

      <!-- local icon -->
      <a href="https://www.alimtiyazgroup.com" target="_blank" class="local-logo">
        <img loading="lazy" src="../../public/alimtiyazgroup-logo-org.webp" alt="alimtiyazgroup logo">
      </a>
    </header>

    <!-- menu for small screens -->
     <header v-if="!bigScreen" class="small-screen">
      
      <!-- top header
        =================
        chery logo + local logo + burgur toggler
         -->
      <div class="top">
        <router-link to="/" tag="a" class="home">
            <img loading="lazy" src="../assets/chery_black.webp" alt="">
          </router-link>

          <!-- local icon -->
          <a href="https://www.alimtiyazgroup.com" target="_blank" class="local-logo">
            <img loading="lazy" src="../../public/alimtiyazgroup-logo-org.webp" alt="alimtiyazgroup logo" style="width: 155px;">
          </a>

          <!-- toggle menu -->
          <div class="burgur" :class="{active: slideDownMenu}" @click="slideDownMenu = !slideDownMenu">
            <div :style="{ background: smallScreen ? 'var(--tech-black)':'var(--white)'}"></div>
            <div :style="{ background: smallScreen ? 'var(--tech-black)':'var(--white)'}"></div>
            <div :style="{ background: smallScreen ? 'var(--tech-black)':'var(--white)'}"></div>
          </div>
      </div>



      <!-- sliderDown menu -->
      <transition name="fade" mode="out-in" appear>
        <div class="menu-down" v-if="slideDownMenu">
          <a @click="service = !service" :class="{active: $route.path.includes('/services')}">service</a>

          <!-- sublist
            ============
            service sub pages
          -->
          <nav class="subList" v-if="service">
            <router-link to="/services/request-quote" tag="a" :class="{active: $route.path.includes('/services/request-quote')}">request quote</router-link>
            <router-link to="/services/test-drive" tag="a" :class="{active: $route.path.includes('/services/test-drive')}">test drive</router-link>
            <router-link to="/services/after-sales" tag="a" :class="{active: $route.path.includes('/services/after-sales')}">after sales</router-link>
            <router-link to="/services/maintenance" tag="a" :class="{active: $route.path.includes('/services/maintenance')}">maintenance reservation</router-link>
            <router-link to="/services/fleet-solutions" tag="a" :class="{active: $route.path.includes('/services/fleet-solutions')}">fleet solutions</router-link>
          </nav>

          <!-- rest of the main pages -->
          <router-link to="/showroom" tag="a" :class="{active: $route.path.includes('/showroom')}">showroom</router-link>
          <router-link to="/about" tag="a" :class="{active: $route.path.includes('/about')}">about chery</router-link>
          <router-link to="/contact" tag="a" :class="{active: $route.path.includes('/contact')}">contact us</router-link>
          <router-link to="/news" tag="a" :class="{active: $route.path.includes('/news')}">news</router-link>


        </div>
      </transition>

      

      
    </header>




    <!-- BIG SCREEN sub menu
     ==============
     service + models (desktop screen)
      -->
    <section v-if="bigScreen">
      <!-- service -->
      <transition name="fade" mode="in-out" appear>
        <div class="service" v-if="service">
          <router-link to="/services/request-quote" tag="a" :class="{active: $route.path.includes('/services/request-quote')}">request quote</router-link>
          <router-link to="/services/test-drive" tag="a" :class="{active: $route.path.includes('/services/test-drive')}">test drive</router-link>
          <router-link to="/services/after-sales" tag="a" :class="{active: $route.path.includes('/services/after-sales')}">after sales</router-link>
          <router-link to="/services/maintenance" tag="a" :class="{active: $route.path.includes('/services/maintenance')}">maintenance reservation</router-link>
          <router-link to="/services/fleet-solutions" tag="a" :class="{active: $route.path.includes('/services/fleet-solutions')}">fleet solutions</router-link>
        </div>
      </transition>

      <!-- models -->
      <transition name="fade" mode="out-in" appear>
        <div class="models" v-if="models">
          
          <button class="close" @click="models=false">
            close 
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>

          <div class="main">
            <div :class="{active: hoverBrand=='tiggo'}" @mouseenter="bindCurrentModel('tiggo')"><img loading="lazy" src="../assets/logos/tiggo.png" alt="brand logo"></div>
            <div :class="{active: hoverBrand=='arrizo'}" @mouseenter="bindCurrentModel('arrizo')"><img loading="lazy" src="../assets/logos/arrizo.png" alt="brand logo"></div>
            <div :class="{active: hoverBrand=='himla'}" @mouseenter="bindCurrentModel('himla')"><img loading="lazy" src="../assets/logos/himla.png" alt="brand logo"></div>
          </div>

          <div class="sub">
            <div class="model-name" v-for="(m, index) in currentModel?.models" :key="index"  @mouseenter="currentCar=m">
              {{ m.model_name }}
            </div>
          </div>

          <div class="preview">
            <div class="car">
              <!-- brand logo -->
              <img loading="lazy" :src="dynamicBrandImg" alt="brand logo" class="brand">
              <!-- car img  -->
              <img loading="lazy" :src="currentCar?.imgURL" alt="car img">
            </div>

            <div class="details">
              <div>
                <div class="engin">
                  <span>Engin</span>
                  <div>
                    {{ currentCar?.engine.toFixed(1) }} <span v-if="currentCar?.turbo">turbo</span>
                  </div>
                </div>

                <div class="hourse-power">
                  <span>Hourse power</span>
                  <div>
                    {{ currentCar?.horsePower}} <span>HP</span>
                  </div>
                </div>
              </div>

              <div>
                <a class="square" :download="currentCar?.modelName" :href="`${currentCar?.catalog}/?download=1`">
                  download catalog
                </a>
                <!-- <a class="square" @click="downloadCatalog(currentCar?.modelName)" :href="currentCar?.catalog">
                  download catalog
                </a> -->
                <a class="square" :href="currentCar?.catalog" target="_blank">
                  View catalog
                </a>
              </div>
            </div>
          </div>

        </div>
      </transition>
    </section>
    
    

  </div>
</template>


<script>
import { defineComponent } from 'vue';
import api from "@/apis.js";

  export default defineComponent({
    props: {
      isHeaderActive: {
        type: Boolean,    // type check
        default: false    // default if parent didn't pass
      }
    },
    data() {
      return {
        bigScreen: true,
        service: false,
        models: false,
        smallScreen: window.innerWidth <= 1024,
        slideDownMenu: false,

        currentModel: null,
        currentCar: null,
        hoverBrand: "tiggo",
        allModels: [],



      }
    },
    computed: {
      dynamicBrandImg() {
        const brandName = this.currentModel?.brandName;
        console.log('from computed: ', brandName);
        
        const logos = {
          tiggo: require('@/assets/logos/tiggo.png'),
          arrizo: require('@/assets/logos/arrizo.png'),
          himla: require('@/assets/logos/himla.png')
        };
        return logos[brandName.toLowerCase()];
     }
    },
    watch: {
      '$route.path'() {
        this.slideDownMenu = false;
        if (window.innerWidth <= 1024) {
          this.service = false;
        }
      }
    },
    methods: {
      fetchingModels() {
        api.get('/models')
        .then(res => {
          this.allModels = res.data;
          this.bindCurrentModel('tiggo');
        })
        .catch(err => console.log(err))
      },
      bindCurrentModel(bname) {
        let x = this.allModels?.find(i => i.brandName.toLowerCase() == bname.toLowerCase());
        // console.log(this.allModels);
        // console.log(bname);
        // console.log(x);
        
        this.currentModel = x;
        this.hoverBrand = bname;
        this.currentCar = x?.models[0];
      },
      downloadCatalog(catalogName) {
        // let url = this.currentCar?.catalog;
        let link = document.createElement('a');
        link.href = this.currentCar?.catalog;
        link.download = `${catalogName} catalog`; // Set the desired filename
        document.body.appendChild(link); // Append the link to the body
        link.click(); // Simulate a click on the link
        document.body.removeChild(link); // Remove the link after the click

      }
    },
    mounted() {
      this.fetchingModels();
      let s = window.innerWidth < 1024;
      if (s) {this.bigScreen = false;}
      else {this.bigScreen = true;}
      window.addEventListener('resize', () => {
        if (window.innerWidth < 1024) {
          /**
           * small screen 
           *    close the menu
           *    change the header
           */
          this.slideDownMenu = false; 
          this.bigScreen = false;
        }
        else {this.bigScreen = true;}
        this.smallScreen = window.innerWidth <= 1024;
      });
    },
    beforeUnmount() {
      window.removeEventListener('resize', () => {});
    }
  })
</script>